/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Deep_P2Inputs */

const en_viewer_deep_p2 = /** @type {(inputs: Viewer_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodes carry a path built as you would write it in code, with dots for object keys and square brackets for array indices, rooted at root. A field three levels down reads as root.user.address.city, and an element inside an array reads as root.items[2].id. Drop the leading root and you have an expression you can paste into your own code or a jq filter.`)
};

const ko_viewer_deep_p2 = /** @type {(inputs: Viewer_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`노드는 코드에 쓰는 방식대로 만들어진 경로를 지닙니다. 객체 키에는 점, 배열 인덱스에는 대괄호를 쓰고 root에서 시작합니다. 세 단계 아래의 필드는 root.user.address.city로 읽히고, 배열 안의 요소는 root.items[2].id로 읽힙니다. 앞의 root를 떼면 자기 코드나 jq 필터에 붙여넣을 수 있는 표현식이 됩니다.`)
};

const ja_viewer_deep_p2 = /** @type {(inputs: Viewer_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノードはコードに書くとおりの形で組まれたパスを持ちます。オブジェクトキーにはドット、配列添字には角かっこを使い、root から始まります。3 段階下のフィールドは root.user.address.city と読め、配列内の要素は root.items[2].id と読めます。先頭の root を落とせば、自分のコードや jq のフィルタに貼れる式になります。`)
};

/**
* | output |
* | --- |
* | "Nodes carry a path built as you would write it in code, with dots for object keys and square brackets for array indices, rooted at root. A field three levels..." |
*
* @param {Viewer_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_deep_p2 = /** @type {((inputs?: Viewer_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_deep_p2(inputs)
	if (locale === "ko") return ko_viewer_deep_p2(inputs)
	return ja_viewer_deep_p2(inputs)
});